import AuthContext from '@modules/auth/providers/AuthContext';
import { useContext } from 'react';

const useAuth = () => {
  return useContext(AuthContext);
};

export default useAuth;
